import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import * as _ from 'lodash';

import { ISlimScrollOptions } from 'ng2-slimscroll';
import { GroupService } from './../group.service';
import { MessageEvent, SignInEvent, OpenFrameEvent, LoaderEvent, SidemenuSubCategory, HiddenFooter, SetAllMemberCheck } from './../../shared/message.event';
import { AppService } from './../../app.service';
import { CONSTANT_VALUES } from '../../constants/constant-values';
import { CONSTANT_MESSAGES } from '../../constants/constants-messages';
import { UISETTING } from './../../shared/ui-setting';
import { BaseGroup } from './../base-group';

@Component({
  selector: 'app-manage-group',
  templateUrl: './manage-group.component.html',
  styleUrls: ['./manage-group.component.css'],
  providers: [GroupService, MessageEvent, SignInEvent, AppService, OpenFrameEvent, LoaderEvent, SidemenuSubCategory,
    HiddenFooter, SetAllMemberCheck]
})
export class ManageGroupComponent extends BaseGroup implements OnInit {
  private shouldSlide: boolean = false;
  private hideEdit: boolean;
  private divHeight = 30;
  private pagebutton = 20;
  private noMemberAvailable: boolean = false;
  private noGroupAvailable: boolean = true;
  private idealStage = false;
  private cancleButton = true;
  private setChecked = [];
  private actionable = false;
  @ViewChild('searchInput')
  searchInputVariable: any;
  private scrollOptions: ISlimScrollOptions;
  private exp;
  private members = [];
  private totalSizeOfList = 0;
  private onePagePerItem = 10; // It will set by vendor configuration object
  private pageOptions = {
    currentPage: 1,
    noOfPageItem: this.onePagePerItem
  };
  private currentFrame = '';
  @ViewChild('memberTable')
  tableVariable: any;
  private createGroupView;
  private description;
  @ViewChild('editGroupPopupObj')
  editPopupVariable: any;
  private memberTableHeight = 55;
  private showFilterGroup = false;
  private disableStartTime = '';
  private activateTitle = '';
  private activateMessage = '';
  private uiSetting: UISETTING;
  private height: any;
  private filterSendInvite = false;
  private sendInviteFliterList = [{ name: 'Sent', status: true }, { name: 'Not Sent', status: false }];
  constructor(private router: Router, private groupService: GroupService, private appService: AppService,
    private openFrameEvent: OpenFrameEvent, private messageEvent: MessageEvent, private signInEvent: SignInEvent,
    private loaderEvent: LoaderEvent, private sidemenuSubCategory: SidemenuSubCategory, private hiddenFooter: HiddenFooter, private setAllMemberCheck: SetAllMemberCheck) {
    super();
    this.uiSetting = {
      'windowHeight': window.innerHeight,
      'topNav': 56,
      'midNav': 45,
      'footer': 35,
      'container': 20
    };
    this.scrollOptions = {
      barBackground: "#343a40", barOpacity: "0.6", position: "right",
      barWidth: "6", barBorderRadius: "5", barMargin: "1px 1px", gridBackground: "#adb5bd", gridOpacity: "1", gridWidth: "4", gridBorderRadius: "10", gridMargin: "1px 2px"
    };
    this.popUpMessage = '';
    this.hideEdit = false;
    this.height = (this.uiSetting.windowHeight - (this.uiSetting.topNav + this.uiSetting.midNav + this.uiSetting.container + this.uiSetting.footer + this.divHeight + this.pagebutton)) + 'px';
    this.exp = false;
    this.createGroupView = false;
    this.message = CONSTANT_MESSAGES.NO_MEMBER_ADDED;
  }

  ngOnInit() {
    let obj = {
      category: 'All Group',
      menu: 'All Group'
    };
    this.sidemenuSubCategory.fire(obj);
    this.vendor = JSON.parse(atob(localStorage.getItem('vendor')));
    this.clubName = this.vendor.clubName;
    if (localStorage.getItem('recentCreatedGroupId')) {
      this.recentCreatedGroup = JSON.parse(atob(localStorage.getItem('recentCreatedGroupId')));
    }
    this.getFacilityListForFilter(this);
    this.getGroupList();
    this.emitOpenFrameEvent();
    this.emitTypeBroadcast();
    this.registerTypeBroadcast();
  }

  /**
   * Fetch MemberList with respect to condo
   */

  getMemberListByGroup(request) {
    let that = this;
    this.noMemberAvailable = false;
    setTimeout(function () {
      request.groupId = that.selectGroupId;
      try {
        that.loaderEvent.fire(false);
        that.groupService.getListOfMemberByGroup(request).then((result: any) => {
          if (result.status === CONSTANT_VALUES.RESPONSE_SUCCESS) {
            that.memberList = result.users;
            that.totalSizeOfList = result.total;
            that.noMemberAvailable = (result.users.length > 0);
            if (!that.noMemberAvailable) {
              that.message = CONSTANT_MESSAGES.NO_MEMBER_ADDED;
            }
            if (that.memberList) {
              that.memberList.map(function (mem) {
                if (!mem.isBlackListed) {
                  mem.enable = 'Active';
                } else {
                  mem.enable = 'Inactive';
                }
                mem.signedUpOn = that.utilityFunctions.maketimeZoneOfsetDate(mem.signedUpOn).format('DD/MM/YYYY');
                if (mem.hasLeftService) {
                  mem.leftServiceDate = that.utilityFunctions.maketimeZoneOfsetDate(mem.leftServiceDate).format('DD/MM/YYYY');
                }
                return mem;
              });
            }
            if (that.memberList.length > 0) {
              that.setCheckedList();
            }
            that.loaderEvent.fire(true);
          } else {
            that.memberList = [];
            this.noMemberAvailable = false;
            that.loaderEvent.fire(true);
          }

        }).catch((err) => {
          that.popUpMessage = err;
          that.loaderEvent.fire(true);
        });
      } catch (e) {
        console.log(e);
      }
    }, 0);
  }

  emitTypeBroadcast() {
    let isShow = {
      privacypolicy: true,
      support: false,
      footer: 'block'
    };
    this.signInEvent.fire('block');
    this.hiddenFooter.fire(isShow);
  }

  emitOpenFrameEvent() {
    this.openFrameEvent.fire(false);
  }

  /**
   * while menu slide left to right as well as we shift header, footer and body too by broadcaster
   */

  registerTypeBroadcast() {
    this.messageEvent.on().subscribe(message => {
      this.shouldSlide = message;
    });
  }

  /**
   * After adding members in group show update group
   */
  onNotify() {
    localStorage.setItem('recentCreatedGroupId', btoa(JSON.stringify(this.selectGroupId)));
    this.getGroupList();
    if (this.currentFrame === 'ADD') {
      this.currentFrame = '';
    }
    this.pagination(this.pageOptions, 1, this.selectGroupId);
  }

  /**
       * Expand search input box
       */
  expand() {
    if ((this.searchMember + '').trim()) {
      this.pagination(this.pageOptions, 1, this.selectGroupId);
    } else {
      this.searchMember = '';
      if (this.exp) {
        this.pagination(this.pageOptions, 1, this.selectGroupId);
      }
      this.exp = !this.exp;
    }
  }

  /**
       * Redirect to another pages
       */
  redirectTo(frameName, popUpObj) {
    if (frameName === 'DEACTIVATE') {
      this.currentFrame = 'DEACTIVATE';
      let popTitle = 'Deactivate';
      let popUpMessage = CONSTANT_MESSAGES.DEACTIVATE_GROUP;
      let isGroupAvailable = false;
      popUpObj.showChildModal(popTitle, popUpMessage, isGroupAvailable);
    } else if (frameName === 'CREATEGROUP') {
      this.router.navigate(['/creategroup']);
    } else if (frameName === 'DISABLE') {
      popUpObj.showChildModal();
    } else if (frameName === 'ACTIVATE') {
      this.currentFrame = 'ACTIVATE';
      this.activateTitle = 'Activate';
      this.activateMessage = CONSTANT_MESSAGES.ACTIVATE_GROUP;
      popUpObj.showChildModal();
    }
  }

  /**
       * Pagination on member list
       */
  pagination(pageOptions, pageNo, groupId) {
    this.filterState = this.filterPara;
    if (groupId && (groupId + '').indexOf(':') > -1) {
      groupId = groupId.split(':')[1].trim();
      this.selectGroupId = groupId;
    }
    if (pageOptions) {
      this.pageOptions = pageOptions;
    }
    let requestObject = {
      groupId: this.selectGroupId,
      perPage: parseInt('' + this.pageOptions.noOfPageItem),
      pageNumber: pageNo ? pageNo : this.pageOptions.currentPage,
      filters: []
    };
    this.tableVariable.currentPage = pageNo ? pageNo : this.pageOptions.currentPage;
    switch (this.filterPara) {
      case 'Inactive':
        requestObject['filters'].push({
          type: 'isDeactivated',
          values: true
        });
        this.message = CONSTANT_MESSAGES.NO_RECORD_FOUND;
        break;
      case 'DisabledFacility':
        requestObject['filters'].push({
          type: 'disabled',
          values: this.facilityFilter,
          applyAll: false
        });
        this.filterStateSubMenuList = JSON.parse(JSON.stringify(this.facilityFilter));
        this.message = CONSTANT_MESSAGES.NO_RECORD_FOUND;
        break;
      case 'Prefernces':
        requestObject['filters'].push({
          type: 'facilityPreference',
          values: this.preferenceFilter,
          applyAll: false
        });
        this.filterStateSubMenuList = JSON.parse(JSON.stringify(this.preferenceFilter));
        this.message = CONSTANT_MESSAGES.NO_RECORD_FOUND;
        break;
      case 'SentInvite':
        if (this.inviteStatusFilter.indexOf(true) >= 0 && this.inviteStatusFilter.indexOf(false) < 0) {
          requestObject['filters'].push({
            type: 'isInviteSent',
            values: true
          });
        }
        if (this.inviteStatusFilter.indexOf(false) >= 0 && this.inviteStatusFilter.indexOf(true) < 0) {
          requestObject['filters'].push({
            type: 'isInviteSent',
            values: false
          });
        }
        if (this.inviteStatusFilter.length == 0) {
          requestObject['filters'] = [];
        }
        this.filterStateSubMenuList = JSON.parse(JSON.stringify(this.inviteStatusFilter));
        this.message = CONSTANT_MESSAGES.NO_RECORD_FOUND;
        break;
    }
    if ((this.searchMember + '').trim()) {
      requestObject['filters'].push({
        type: 'search',
        values: this.searchMember
      });
      this.message = CONSTANT_MESSAGES.NO_RECORD_FOUND;
    }
    if (this.currentFrame === 'ADD') {
      requestObject['vendorId'] = this.vendor._id;
      this.getMemberListExceptCurrentGroup(requestObject);
      if (this.memberList.length > 0) {
        this.setCheckedList();
      }
    } else {
      this.getMemberListByGroup(requestObject);
    }
  }

  /**
   * Add member in group
   */
  addMemberInList(memberObj: any) {
    if (memberObj.isChecked) {
      this.members.push(memberObj.userId);
      this.setChecked.push(memberObj.userId);
    } else {
      _.remove(this.members, function (n) {
        return n === memberObj.userId;
      });
      _.remove(this.setChecked, function (n) {
        return n === memberObj.userId;
      });
      if (this.tableVariable.allInGroup) {
        this.tableVariable.allInGroup = false;
      }
    }
    if (this.members.length === 0) {
      this.tableVariable.allInGroup = false;
    }
  }
  /**
   * Remove member from group
   */
  removeMemberFromGroup(bool: boolean, popUpObj) {
    if (bool) {
      let groupEle = {
        groupId: this.selectGroupId,
        members: this.members
      };
      if (groupEle.members.length > 0) {
        this.groupService.removeMemberFromGroup(groupEle).then((result: any) => {
          if (result.status === CONSTANT_VALUES.RESPONSE_SUCCESS) {
            this.popUpMessage = result.message;
            this.members = [];
            this.createGroupView = false;
            this.idealStage = false;
            this.tableVariable.allInGroup = false;
            popUpObj.showChildModal();
          } else {
            this.popUpMessage = result.message;
            popUpObj.showChildModal();
          }
          this.actionable = false;
          this.loaderEvent.fire(true);
        })
          .catch((err) => {
            this.popUpMessage = err;
            this.loaderEvent.fire(true);
          });
      } else {
        this.popUpMessage = CONSTANT_MESSAGES.REMOVE_MEMBERS;
        popUpObj.showChildModal();
      }
    }
  }

  /**
 * Fetch MemberList with respect to condo
 */

  getMemberListExceptCurrentGroup(request) {
    try {
      this.loaderEvent.fire(false);
      let that = this;
      this.groupService.getMemberListNotInGroup(request).then((result: any) => {
        if (result.status === CONSTANT_VALUES.RESPONSE_SUCCESS) {
          this.memberList = result.users;
          this.totalSizeOfList = result.total;
          this.tableVariable.allInGroup = false;
          this.noMemberAvailable = (result.users.length > 0);
          this.memberList.map(function (mem) {
            mem.receivedMessage = 'Not Received';
            mem.hideEdit = false;
            if (!mem.isBlackListed) {
              mem.enable = 'Active';
            } else {
              mem.enable = 'Inactive';
            }
            mem.signedUpOn = that.utilityFunctions.maketimeZoneOfsetDate(mem.signedUpOn).format('DD/MM/YYYY');
            if (mem.hasLeftService) {
               mem.leftServiceDate = that.utilityFunctions.maketimeZoneOfsetDate(mem.leftServiceDate).format('DD/MM/YYYY');
            }
            return mem;
          });
          this.loaderEvent.fire(true);
        } else {
          this.loaderEvent.fire(true);
          this.memberList = [];
          this.noMemberAvailable = (result.memberList.length > 0);
        }
      })
        .catch((err) => {
          this.popUpMessage = err;
          this.loaderEvent.fire(true);
        });
    } catch (e) {
      console.log(e);
    }
  }

  /**
 * Edit group name
 */
  editGroupName(popUpObj) {
    let groupObject = this.groupList.length > 0 ? _.find(this.groupList, { _id: this.selectGroupId }) : {};
    this.editPopupVariable.groupName = groupObject.name;
    this.description = groupObject.description;
    popUpObj.showChildModal(this.description);
  }

  /**
 * Confirmation popup for remove member
 */
  confirmationOfRemoveMembers(popUpObjOnRemove, popUpObj) {
    if (this.members.length <= 0) {
      this.popUpMessage = CONSTANT_MESSAGES.REMOVE_MEMBERS;
      popUpObj.showChildModal(1);
    } else {
      this.popUpMessage = CONSTANT_MESSAGES.CONFIRMATION_REMOVE_MEMBER;
      popUpObjOnRemove.showChildModal();
    }
  }
  /**
 * Select all  member for add or remove
 */
  allMembersSelect(members) {
    this.setChecked = this.setChecked.concat(members);
    this.members = this.setChecked;
    if (!this.tableVariable.allInGroup) {
      this.members = [];
      this.setChecked = _.difference(this.setChecked, members);
    }
  }
  /**
     * Reset page
     */
  reset() {
    this.members = [];
    this.createGroupView = false;
    this.currentFrame = '';
    this.idealStage = false;
    this.tableVariable.allInGroup = false;
    this.actionable = false;
    this.pagination(this.pageOptions, 1, this.selectGroupId);
  }

  /**
     * Add new members in existing group
     */
  addMembersInExistingGroup(bool: boolean, popUpObj) {
    if (bool) {
      let groupEle = {
        groupId: this.selectGroupId,
        newMembers: this.members
      };
      if (groupEle.newMembers.length > 0) {
        this.groupService.addMemberInExistingGroup(groupEle).then((result: any) => {
          if (result.status === CONSTANT_VALUES.RESPONSE_SUCCESS) {
            this.popUpMessage = result.message;
            this.members = [];
            this.createGroupView = false;
            this.idealStage = false;
            popUpObj.showChildModal();
          } else {
            this.popUpMessage = result.message;
            popUpObj.showChildModal();
          }
          this.loaderEvent.fire(true);
          this.actionable = false;
        })
          .catch((err) => {
            this.popUpMessage = err;
            this.loaderEvent.fire(true);
          });
      } else {
        this.popUpMessage = CONSTANT_MESSAGES.ADD_MEMBER;
        popUpObj.showChildModal();
      }
    }
  }

  /**
     * Confirmation to add new member in existing group
     */
  confirmationOfAddMembers(popUpObjForAdd, popUpObj) {
    if (this.members.length <= 0) {
      this.popUpMessage = CONSTANT_MESSAGES.ADD_MEMBER;
      popUpObj.showChildModal(1);
    } else {
      this.popUpMessage = CONSTANT_MESSAGES.CONFIRMATION_ADD_MEMBER;
      popUpObjForAdd.showChildModal();
    }
  }

  /**
     * Got to home screen
     */
  homeScreen() {
    this.utilityFunctions.homeScreen(this);
  }
  /**
     * Get group list by vendor
     */
  getGroupList() {
    let vendorObj = { vendorId: this.vendor._id };
    this.appService.getListOfGroup(vendorObj).then((result: any) => {
      if (result.status === CONSTANT_VALUES.RESPONSE_SUCCESS) {
        this.groupList = result.groups;
        this.selectGroupId = this.groupList[0]._id;
        this.selectGroup = this.groupList[0];
        this.isGroupDisable = this.groupList[0].isActivated;
        if (this.groupList.length > 0 && localStorage.getItem('recentCreatedGroupId')) {
          this.recentCreatedGroup = JSON.parse(atob(localStorage.getItem('recentCreatedGroupId')));
          for (let group of this.groupList) {
            if (group._id === this.recentCreatedGroup) {
              this.selectGroupId = group._id;
              this.selectGroup = group;
              this.isGroupDisable = group.isActivated;
              localStorage.removeItem('recentCreatedGroupId');
            }
          }
        }
        this.noGroupAvailable = (this.groupList.length > 0);
        if (!this.noGroupAvailable) {
          this.message = CONSTANT_MESSAGES.NO_GROUP;
        }
        this.pagination(this.pageOptions, 1, this.selectGroupId);
      } else {
        this.message = CONSTANT_MESSAGES.NO_GROUP;
        this.noGroupAvailable = false;
      }
    });
  }


  /**
       * Maintain selected list against pagination
       */
  setCheckedList() {
    try {
      let flagAllChecked = true;
      for (let rec of this.setChecked) {
        for (let mem of this.memberList) {
          if (rec === mem.userId) {
            mem.isChecked = true;
            break;
          }
        }
      }
      for (let mem of this.memberList) {
        if (!mem.isChecked) {
          flagAllChecked = false;
          break;
        }
      }
      if (flagAllChecked) {
        this.tableVariable.allInGroup = true;
      } else {
        this.tableVariable.allInGroup = false;
      }
    } catch (e) {
      console.log(e);
    }
  }


  /**
       * Reset all check boxes
       */
  resetCheckBox() {
    this.tableVariable.allInGroup = false;
    this.memberList.map(function (rec: any) {
      rec.isChecked = false;
      return rec;
    });
  }

  /**
       * Show popup to disable group
       */
  showDisableGroupPopup(disablePopupObj) {
    disablePopupObj.showChildModal();
  }

  /**
       * Disable member in a group
       */
  disableMember(obj: any, popUpObj) {
    let start, end;
    if (obj.startTime && obj.endTime) {
      start = new Date(obj.startTime).setHours(0, 0, 0, 0);
      end = new Date(obj.endTime).setHours(24, 0, 0, 0);
      start = new Date(start).toISOString();
      end = new Date(end).toISOString();
    }
    let disableGroup = {
      'startTime': this.utilityFunctions.maketimeZoneOfsetDate(start, true),
      'endTime': this.utilityFunctions.maketimeZoneOfsetDate(end, true),
      'groupIds': [this.selectGroupId],
      'action': obj.action,
      'vendorId': this.vendor._id,
      'facilityIds': [obj.facility._id],
      'facilityName': obj.facility.name,
      'reason': obj.reason,
      'clubName': this.vendor.clubName
    };
    this.loaderEvent.fire(false);
    this.groupService.groupActionAPI(disableGroup).then((result: any) => {
      if (result.status === CONSTANT_VALUES.RESPONSE_SUCCESS) {
      } else {
      }
      this.popUpMessage = result.message;
      popUpObj.showChildModal();
      this.loaderEvent.fire(true);
    });

    this.actionable = false;
  }
  /**
       * Make inactive a group
       */
  makeInactive(request, popUpObj) {
    let start, end;
    start = new Date(request.startDate).setHours(0, 0, 0, 0);
    start = new Date(start).toISOString();
    if (request.endDate) {
      end = new Date(request.endDate).setHours(24, 0, 0, 0);
      end = new Date(end).toISOString();
    } else {

    }
    let reqObject = {
      vendorId: this.vendor._id,
      startTime: this.utilityFunctions.maketimeZoneOfsetDate(start, true),
      endTime: end ? this.utilityFunctions.maketimeZoneOfsetDate(end, true) : null,
      groupIds: [this.selectGroupId],
      action: 'deactivate',
      facilityIds: [],
      reason: request.reason
    };
    this.loaderEvent.fire(false);
    this.groupService.groupActionAPI(reqObject).then((result: any) => {
      if (result.status === CONSTANT_VALUES.RESPONSE_SUCCESS) {
      } else {
      }
      this.popUpMessage = result.message;
      popUpObj.showChildModal();
      this.loaderEvent.fire(true);
    });
  }

  /**
       * Make active a group
       */
  makeActivate(bool, popUpObj) {
    if (bool) {
      let reqObject = {
        groupIds: [this.selectGroupId],
        action: 'activate',
        vendorId: this.vendor._id,
      };
      this.loaderEvent.fire(false);
      this.groupService.groupActionAPI(reqObject).then((result: any) => {
        if (result.status === CONSTANT_VALUES.RESPONSE_SUCCESS) {
        } else {
        }
        this.popUpMessage = result.message;
        popUpObj.showChildModal();
        this.loaderEvent.fire(true);
      });
    }
  }

  /**
       * Show specific group information
       */
  groupChange(groupId) {
    this.setChecked = [];
    this.members = [];
    this.actionable = false;
    this.selectGroupId = this.selectGroup._id;
    if (groupId && (groupId + '').indexOf(':') > -1) {
      groupId = groupId.split(':')[1].trim();
    }
    for (let group of this.groupList) {
      if (group._id === this.selectGroupId) {
        this.isGroupDisable = group.isActivated;
        break;
      }
    }
    this.pagination(null, 1, this.selectGroupId);
  }
  /**
       * Confirmation to delete group
       */
  confirmationOfDeleteGroup(popupObj) {
    try {

      for (let group of this.groupList) {
        if (group._id === this.selectGroupId) {
          this.selectGroupName = group.name;
          break;
        }
      }
      this.popUpMessage = CONSTANT_MESSAGES.CONFIRMATION_DELETE_GROUP_PART1 + ' ' + this.selectGroupName + ' ' +
        CONSTANT_MESSAGES.CONFIRMATION_DELETE_GROUP_PART2;
      popupObj.showChildModal();
    } catch (e) {

    }
  }

  /**
       * Redirect to listing screen
       */
  navigateToGroupList(bool: any) {
    try {
      if (bool) {
        this.router.navigate(['/managegroup']);
      }
    } catch (e) {

    }
  }
  setActionableButton() {
    this.actionable = true;
  }

  linkActivities(linkActivityPopup) {
    linkActivityPopup.showChildModal(this.selectGroup);
  }
}



// WEBPACK FOOTER //
// ./src/app/group/manage-group/manage-group.component.ts